export default __webpack_public_path__ + "static/media/tab-opened.772090c3.svg";